<template>
  <div>
    <label class="label">Tipologia</label>
    <!-- bug: label="Tipologia" -->
    <b-field>
      <b-select
        placeholder="Seleziona tipologia"
        v-model="content"
        :required="required"
        :expanded="expanded"
      >
        <option
          v-for="option in $ajax.getObject('servicesTipology')"
          :value="option.id"
          :key="option.id"
        >
          {{ option.name }}
        </option>
      </b-select>

      <div class="control" v-if="this.nullable && this.content">
        <b-tooltip label="Reset campo" position="is-left" animated>
          <a class="button is-outlined" v-on:click="handleReset">
            <b-icon
              pack="fas"
              icon="backspace"
              size="is-small"
              type="is-danger"
            ></b-icon>
          </a>
        </b-tooltip>
      </div>
    </b-field>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },

    required: Boolean,
    expanded: Boolean,
    nullable: Boolean,
  },
  data() {
    return {
      content: this.value,
    };
  },
  methods: {
    handleReset() {
      this.content = null;
    },
  },
  watch: {
    value: function (newVal) {
      this.content = newVal;
    },
    content: function (newVal) {
      localStorage.defaults_card_tipology = newVal;
      this.$emit("input", newVal);
    },
  },
  mounted() {
    if (this.value == null && localStorage.defaults_card_tipology)
      this.content = localStorage.defaults_card_tipology;
  },
};
</script>
